import "./TrialUserHome.css";

import React, { useState } from "react";

import Header from "../../components/HomeHeader";
import LoginSignUpPopup from "../../../../components/LoginSignUpPopup/LoginSignUpPopup";
import RightView from "../RightView/RightView";
import { epochToDateString } from "../../../../helper";

const TrialUserHome = ({ homeData }) => {
  const [showLogin, setShowLogin] = useState<boolean>(false);
  const [showRegister, setShowRegister] = useState<boolean>(false);

  const handleLoginClick = (showType: "login" | "register") => {
    setShowRegister(showType === "register");
    setShowLogin(true);
  };

  const handleCloseModal = () => {
    setShowLogin(false);
  };

  return (
    <div className="trialUser-view">
      <div className="left-view">
        <Header />
        {homeData.data.map((item, itemIndex) => {
          const isFistBriefing = itemIndex === 0;
          return (
            <div key={item.id} style={{ marginTop: isFistBriefing ? 0 : 40 }}>
              <div className="date">
                {epochToDateString(item.createdAt._seconds)}
              </div>
              {item?.stories?.map((story, storyIndex) => {
                const halfStoryLength = Math.floor(story.content.length / 4);
                const halfStory = story.content.slice(0, halfStoryLength);
                const restHalf = story.content.slice(halfStoryLength);
                return (
                  <div key={story.id} style={{ marginBottom: 50 }}>
                    <div className="title">
                      <span className="title-heading">{story.heading}</span>
                    </div>
                    <div className="trial-story-description">
                      <span
                        className="visible-text"
                        dangerouslySetInnerHTML={{
                          __html:
                            isFistBriefing && storyIndex === 0
                              ? halfStory
                              : story.content,
                        }}
                      />

                      {isFistBriefing && storyIndex === 0 && (
                        <div className="blurred-section">
                          <span
                            className="blurred-text"
                            dangerouslySetInnerHTML={{ __html: restHalf }}
                          />
                          <div className="locked-content">
                            <img
                              src="./assets/Lock.png"
                              alt="lockImg"
                              className="locked-img"
                            />
                            <span className="found-interesting">
                              Found this story interesting?
                            </span>
                            <br />
                            <span className="found-interesting-detail">
                              Read the full story and more by starting a free
                              trial.
                            </span>
                            <div className="button-group">
                              <div>
                                <button
                                  className="free-trial-button"
                                  onClick={() => handleLoginClick("register")}
                                >
                                  Start Free Trial
                                </button>
                              </div>
                              <button
                                className="subscriber-login-button"
                                onClick={() => handleLoginClick("login")}
                              >
                                Subscriber Login
                              </button>
                            </div>
                            <span className="subscriber-info">
                              The author made this story available to people
                              Registered as a Subscriber to instantly
                              <br />
                              unlock this story plus other premium Subscriber
                              benefits.
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}

        {/* <button className='dbtn'>news</button> */}

        {/* <div className='leftview'>
          {homeData.data.map((newsItem, index) => (
            <div key={index} className='news-item'>
              <div className='news-content'>
                <div className='heading'>{newsItem.data}</div>
                <div className='leftdescription'>{newsItem.content}</div>
              </div>
              <span>
                <img
                  src={newsItem.img}
                  alt={newsItem.img}
                  className='news-img'
                />
              </span>
            </div>
          ))}
        </div> */}
      </div>

      <RightView homeData={homeData} />
      {showLogin && (
        <LoginSignUpPopup
          onClose={handleCloseModal}
          showRegister={showRegister}
        />
      )}
    </div>
  );
};

export default TrialUserHome;
